import React, { useState, useEffect, useRef } from "react";
import { FaSearch, FaBell, FaBook, FaUserCircle, FaChartLine, FaList, FaCog, FaSignOutAlt, FaUser, FaCogs } from "react-icons/fa";
import { useNavigate, useLocation, Link } from 'react-router-dom';


const Profile = () => {
    const [profileMenuOpen, setProfileMenuOpen] = useState(false);
    const menuRef = useRef(null);
  const [displayname, setDisplayname] = useState(null); // Store the username
  const navigate = useNavigate();
  const [user, setUser] = useState({
    displayname: '',
    username: '',
    email: '',
    role: ''
  });

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user'));
    if (storedUser) {
      setUser({
        displayname: storedUser.displayname || '',
        username: storedUser.username || '',
        email: storedUser.email || '',
        role: storedUser.role || ''
      });
    }
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setProfileMenuOpen(false);
      }
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);


  const handleSettings = () => {
    // Redirect the user to the login page
    navigate('/ProfilePage');
  };

  const handlePassword = () => {
    // Redirect the user to the login page
    navigate('/PasswordPage');
  };

  const handleLogout = () => {
    // Clear the token and user from localStorage
    localStorage.removeItem('token');
    localStorage.removeItem('user');

    // Redirect the user to the login page
    navigate('/');
  };

  return (
    <div className="relative" ref={menuRef}>
    <button onClick={() => setProfileMenuOpen(!profileMenuOpen)}>
      <FaUserCircle size={28} />
    </button>
    {profileMenuOpen && (
      <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-300 rounded-lg shadow-lg z-50">
        <ul className="py-2 text-gray-900">
          <li className="px-4 py-2 hover:bg-gray-100 flex items-center space-x-2 cursor-pointer">
            <FaUser /> <span>{user.displayname ? `Hello, ${user.displayname}` : `Hello, ${user.username}`}</span>
          </li>
          <li className="px-4 py-2 hover:bg-gray-100 flex items-center space-x-2 cursor-pointer">
            <FaCogs /> <span onClick={handleSettings}>Edit Profile</span>
          </li>
          <li className="px-4 py-2 hover:bg-gray-100 flex items-center space-x-2 cursor-pointer text-blue-600">
            <FaSignOutAlt /> <span onClick={handlePassword}>Change Password</span>
          </li>
          <li className="px-4 py-2 hover:bg-gray-100 flex items-center space-x-2 cursor-pointer text-red-600">
            <FaSignOutAlt /> <span onClick={handleLogout}>Logout</span>
          </li>
        </ul>
      </div>
    )}
  </div>
  );
};

export default Profile;
